import { useQuery } from "react-query";
import { getVendorInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetAllVendorInvoiceCount = () => {
  return useQuery("GetVendorInvoiceCount", getVendorInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetAllVendorInvoiceCount;
